import { Permiso } from './../../../../../../_entities/Enums/permiso.enum';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { MapaService } from './../../../../services/mapa.service';
import { ToastrService } from 'ngx-toastr';
import { PuntosInteresService } from './../../../../services/puntos-interes.service';
import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { GuardarPuntoInteresComponent } from '../guardar-punto-interes/guardar-punto-interes.component';


@Component({
	selector: 'kt-puntos-interes-modal',
	templateUrl: './puntos-interes-modal.component.html',
	styleUrls: ['./puntos-interes-modal.component.scss']
})
export class PuntosInteresModalComponent implements OnInit {
	public currentFilter: any;
	public puntosInteres: any[];
	public showFilterRow: boolean;
	public showHeaderFilter: boolean;
	public permisoConsultarPuntosInteres: string;
	public permisoEliminarPuntosInteres: string;
	public datosReporte = [];
	public isDisabled: boolean = true;

	constructor(private puntosService: PuntosInteresService,
		private dialog: MatDialog,
		private mapaService: MapaService,
		public dialogRef: MatDialogRef<PuntosInteresModalComponent>) {
		this.showFilterRow = true;
		this.showHeaderFilter = true;
	}

	async ngOnInit() {
		await this.obtenerPuntos();
		this.obtenerPermisosPuntosInteres();
	}

	public obtenerPuntos = () => {
		this.puntosService.getPuntos().subscribe((res: any[]) => {
			this.puntosInteres = res;
			this.puntosInteres.forEach(punto => {
				this.datosReporte.push({
					'Nombre': punto.nombre,
					'Descripción': punto.descripcion
				});
			});
			if (this.datosReporte.length > 0) {
				this.isDisabled = false;
			}
		}, error => {
			console.log('Ocurrio un error', error);
		});
	}


	public get Permiso() {
		return Permiso;
	}


	eliminarPunto(data: any) {
		Swal.fire({
			title: 'Eliminar',
			text: `¿Está seguro que desea eliminar el punto de interés ${data.nombre}?`,
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: 'Confirmar',
			cancelButtonText: "Cancelar"
		}).then((result) => {
			if (result.value) {
				this.puntosService.deletePunto(data.id).subscribe(() => {
					Swal.fire(
						'Eliminado!',
						'El punto de interés ha sido eliminado.',
						'success'
					).then((resultok) => {
						if (resultok.value) {
							this.pintarMarcadoresPuntosInteres();
							this.obtenerPuntos();
							//location.reload();
						}
					});
				}, error => {
					Swal.fire(
						'Ops!',
						'Error al intentar eliminar el punto de interés.',
						'error'
					);
				})
			}
		})

	}

	public pintarMarcadoresPuntosInteres() {
		this.puntosService.getPuntos().subscribe(
			(res: any[]) => {
				this.mapaService.pintarPuntosInteres(res);
			}, err => {
			});
	}

	verPunto(data: any) {
		this.puntosService.getPutoByID(data.id).subscribe(res => {
			console.log('service punto:', res);
			//this.mapaService.pintarPunto(data);
			this.mapaService.verPunto(data);
		}, err => {
			console.log('error', err);
		})
	}

	editarPuntoInteres(data) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.width = "30%";
		dialogConfig.closeOnNavigation = true;
		dialogConfig.hasBackdrop = false;
		dialogConfig.panelClass = 'custom-modalbox';
		dialogConfig.data = data;
		const dialogRef = this.dialog.open(GuardarPuntoInteresComponent, dialogConfig);
		dialogRef.afterClosed().subscribe(() => {
			//this.vectorPInteresSource.clear();
			this.obtenerPuntos();
		});
	}

	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}

	/**Obtener permisos de punto de interes */
	obtenerPermisosPuntosInteres() {
		this.permisoConsultarPuntosInteres = Permiso.VisualizarPuntosInteres;
		this.permisoEliminarPuntosInteres = Permiso.EliminarPuntoInteres;
	}


}
